/*  Shared  */
import { LastUpdatedCard } from 'application/Shared/Components/Cards/Components/LastUpdatedCard';
import { Route } from 'application/Shared/Helpers';
import { formatDistanceToNow } from 'application/Shared/Helpers/Dates';

/* Hooks */
import { useFetchUserApplications } from 'hooks/dataAccess/User/userApplication';

/*  React  */
import React, { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

export const UserTotalAppsCard = () => {
    const { t } = useTranslation();
    const { clientId, userId, partnerId } = useParams();
    const route = Route.buildBaseAdminRoute({ clientId, partnerId });

    const paramsGetOne = useMemo(
        () => ({
            includeUnclassified: true,
            platformUserId: userId,
            size: 1,
            sort: 'dateCreated'
        }),
        [userId]
    );

    const paramsGetAll = useMemo(
        () => ({
            includeUnclassified: true,
            platformUserId: userId,
            size: -1
        }),
        [userId]
    );

    const { userApps } = useFetchUserApplications({
        clientId,
        getOne: true,
        params: paramsGetOne
    });

    const { userAppsCount } = useFetchUserApplications({
        clientId,
        params: paramsGetAll
    });

    const applicationLastAddedDate = userApps?.dateCreated;

    return (
        <LastUpdatedCard
            content={userAppsCount || '-'}
            buttonText={t('UserDashboard.view_applications')}
            lastUpdated={
                <Trans
                    i18nKey="UserDashboard.last_app_added"
                    components={{
                        Date: applicationLastAddedDate ? (
                            <>{formatDistanceToNow(applicationLastAddedDate)}</>
                        ) : (
                            <>{t('Common.never')}</>
                        )
                    }}
                />
            }
            route={`${route}/user/${userId}/admin`}
            title={t('Common.total_applications')}
        />
    );
};
